export interface TruncateTextOptions {
  maxChars?: number;
  ellipsis?: boolean;
  shownChars?: number;
}

export const truncateText = (
  string?: string | null,
  options?: TruncateTextOptions,
) => {
  if (!string) return '';
  const { maxChars = 30, ellipsis = true, shownChars = 4 } = options || {};
  if (string.length < maxChars) {
    return string;
  }
  if (ellipsis) {
    return `${string.slice(0, shownChars)}...${string.slice(-shownChars)}`;
  }
  return string.slice(maxChars);
};
